/* eslint-disable max-len */
import React from 'react';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import momentLocalizer from 'react-widgets-moment';
import { Label, FormGroup, Col } from 'reactstrap';
import 'react-widgets/dist/css/react-widgets.css';
import isEmpty from 'lodash/isEmpty';

momentLocalizer();

// eslint-disable-next-line import/prefer-default-export
export const RenderDateTimePickerNew = ({
  input: { onChange, value },
  label,
  name,
  isNew,
  initialDate,
  showTime,
}) => (
  <FormGroup row>
    {!isEmpty(label) && (
    <Label for={name} sm="2">
      {label}
    </Label>
    )}
    <Col sm="10">
      <DateTimePicker
        onChange={onChange}
        format="DD MMM YYYY"
        time={showTime}
        // eslint-disable-next-line no-nested-ternary
        value={!isNew ? (value.seconds ? new Date(initialDate.seconds * 1000) : new Date(value)) : new Date(value)}
      />
    </Col>
  </FormGroup>
);
